var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsQzConnected } from '../../../redux/packing';
export var useWeightStationHeartbeat = function (_a) {
    var enabled = _a.enabled, shipmentId = _a.shipmentId, shipmentPackageSeqId = _a.shipmentPackageSeqId, _b = _a.pollIntervalMs, pollIntervalMs = _b === void 0 ? 5000 : _b, loadPackageWeight = _a.loadPackageWeight, onWeightReceived = _a.onWeightReceived;
    var isQzConnected = useSelector(selectIsQzConnected);
    var pollRef = useRef(null);
    var clockRef = useRef(null);
    var isPollInFlightRef = useRef(false);
    var onWeightReceivedRef = useRef(onWeightReceived);
    var sourceKeyRef = useRef('');
    var _c = useState(null), lastWeightReceivedAt = _c[0], setLastWeightReceivedAt = _c[1];
    var _d = useState(Date.now()), clockNow = _d[0], setClockNow = _d[1];
    var isPollingEnabled = enabled && isQzConnected;
    var hasActiveSource = Boolean(isPollingEnabled && shipmentId);
    var sourceKey = (shipmentId || '') + ":" + (shipmentPackageSeqId || '');
    var clearPolling = useCallback(function () {
        if (pollRef.current) {
            window.clearInterval(pollRef.current);
            pollRef.current = null;
        }
    }, []);
    var clearClock = useCallback(function () {
        if (clockRef.current) {
            window.clearInterval(clockRef.current);
            clockRef.current = null;
        }
    }, []);
    useEffect(function () {
        onWeightReceivedRef.current = onWeightReceived;
    }, [onWeightReceived]);
    var pullWeightFromStation = useCallback(function (expectedSourceKey) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shipmentId || isPollInFlightRef.current)
                        return [2 /*return*/];
                    isPollInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, loadPackageWeight(shipmentId, shipmentPackageSeqId)];
                case 2:
                    result = _a.sent();
                    if (sourceKeyRef.current !== expectedSourceKey)
                        return [2 /*return*/];
                    if ((result === null || result === void 0 ? void 0 : result.weight) !== null && (result === null || result === void 0 ? void 0 : result.weight) !== undefined) {
                        onWeightReceivedRef.current(result.weight);
                        setLastWeightReceivedAt(Date.now());
                    }
                    return [3 /*break*/, 4];
                case 3:
                    isPollInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [loadPackageWeight, shipmentId, shipmentPackageSeqId]);
    useEffect(function () {
        sourceKeyRef.current = sourceKey;
        isPollInFlightRef.current = false;
        if (!isPollingEnabled) {
            clearPolling();
            setLastWeightReceivedAt(null);
            return;
        }
        setLastWeightReceivedAt(null);
        clearPolling();
        if (shipmentId) {
            void pullWeightFromStation(sourceKey);
            pollRef.current = window.setInterval(function () {
                void pullWeightFromStation(sourceKey);
            }, pollIntervalMs);
        }
        else {
            clearPolling();
        }
        return function () {
            clearPolling();
            isPollInFlightRef.current = false;
        };
    }, [
        clearPolling,
        isPollingEnabled,
        pollIntervalMs,
        pullWeightFromStation,
        sourceKey,
        shipmentId,
        shipmentPackageSeqId
    ]);
    useEffect(function () {
        if (!isPollingEnabled) {
            clearClock();
            return;
        }
        clockRef.current = window.setInterval(function () {
            setClockNow(Date.now());
        }, 1000);
        return function () {
            clearClock();
        };
    }, [clearClock, isPollingEnabled]);
    var weightAgeSeconds = useMemo(function () {
        if (!lastWeightReceivedAt)
            return null;
        return Math.max(0, Math.floor((clockNow - lastWeightReceivedAt) / 1000));
    }, [clockNow, lastWeightReceivedAt]);
    var weightPulseClass = useMemo(function () {
        if (weightAgeSeconds === null)
            return 'bg-gray-300';
        if (weightAgeSeconds <= 8)
            return 'bg-green-500 animate-pulse';
        if (weightAgeSeconds <= 20)
            return 'bg-yellow-400';
        return 'bg-red-400';
    }, [weightAgeSeconds]);
    return {
        lastWeightReceivedAt: lastWeightReceivedAt,
        weightAgeSeconds: weightAgeSeconds,
        weightPulseClass: weightPulseClass,
        hasActiveSource: hasActiveSource,
        isQzConnected: isQzConnected
    };
};
export default useWeightStationHeartbeat;
